import { defineMessages } from 'react-intl';

export const giftCardConfirmationHeaderButtonsMessages = defineMessages({
  backButtonA11yLabel: {
    defaultMessage: 'Navigate to the previous screen',
    description:
      'Gift Card Confirmation Screen | Navigation Header | Back button a11y label',
  },
});
